import {EventEmitter, Injectable, Output} from '@angular/core';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";

@Injectable()
export class UserSearchResultsService {

  @Output() deactivateTopMenuActivePosition = new EventEmitter<boolean>();

  constructor(

  ) {

}

  deactivateTopMenu() {
    this.deactivateTopMenuActivePosition.emit(true);
  }

}
